module.exports = __webpack_public_path__ + "static/media/feature.f5c346d1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/WhatWeveDone/BunburyTurfClub/feature.jpg
// module id = 211
// module chunks = 0